import { Messages } from '~src/codegen/Localize';
import { ContentTypeFilterClause,ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { GenericCard } from '~src/spacesPlatform/components/card/GenericCard';
import { SubscriptionContentType } from '~src/spacesPlatform/models/ContentTypes';
import { Subscriptions } from '~src/subscription/models/Subscriptions';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';

import { getGenericDefaultFilters } from '../../contentDefinitions/getDefaultFilters';

export const SubscriptionDefinition: ExplorableItemDefinition = {
  itemType: 'subscription',
  pluralName: Messages.subscriptions,
  singularName: Messages.subscription,
  emptyStateMessage: Messages.subscriptionsEmptyMessage,
  contentFilterKeys: SubscriptionContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['subscription']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return Subscriptions.all().withExtraParams(SubscriptionContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
